import { useTheme } from '@emotion/react'
import PropTypes from 'prop-types'
import LinearProgress from '@mui/material/LinearProgress'
import { ThemeProvider } from '@mui/material/styles'
import muiTheme from '../../themes/muiTheme'

// GuidedChoice brand blue, used only when the white-label theme is missing.
const FALLBACK_FILL = '#038ab7'
const FALLBACK_TRACK = '#e6e9ea'

/**
 * Desktop step-by-step advice progress bar.
 *
 * A single continuous bar whose width represents `totalSteps`. It fills
 * proportionally with the client's brand color as the user advances through
 * the flow (including the final summary screen).
 */
const DesktopProgressBar = props => {
  const { totalSteps, currentStep, fillColor, trackColor, className } = props
  const theme = useTheme()

  const clampedStep = Math.min(Math.max(currentStep, 0), totalSteps)
  const value = totalSteps > 0 ? (clampedStep / totalSteps) * 100 : 0

  return (
    <ThemeProvider theme={muiTheme}>
      <LinearProgress
        className={className}
        variant='determinate'
        value={value}
        aria-label={`Step ${clampedStep} of ${totalSteps}`}
        sx={{
          'height': '6px',
          'borderRadius': '190px',
          'backgroundColor': trackColor || theme.homeActionButtonBgColor || FALLBACK_TRACK,
          '& .MuiLinearProgress-bar': {
            borderRadius: '190px',
            backgroundColor: fillColor || theme.primaryColor || FALLBACK_FILL,
          },
        }}
      />
    </ThemeProvider>
  )
}

DesktopProgressBar.propTypes = {
  totalSteps: PropTypes.number.isRequired,
  currentStep: PropTypes.number.isRequired,
  fillColor: PropTypes.string,
  trackColor: PropTypes.string,
  className: PropTypes.string,
}

export default DesktopProgressBar
